<template>
  <div id="app">
    <!-- <transition name="fade-transform" mode="out-in">
      <keep-alive>
        <router-view :key="key" v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
    </transition>
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" v-if="!$route.meta.keepAlive"></router-view>
    </transition> -->
    <keep-alive>
      <router-view :key="key" v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view :key="key" v-if="!$route.meta.keepAlive"></router-view>
    <!-- 电话服务 -->
    <ola :ext-no="getUserInfo.extNo" v-if="!!this.$store.state.userInfo.extNo"/>
  </div>
</template>
<script>
import { getDiseaseType, getMemberHealthTagList, getThreeFactorsList, getSymptomTree } from '@/api/index'
import { mapGetters, mapActions } from 'vuex'
import 'viewerjs/dist/viewer.css'

// 电话
import Ola from '@/components/ola/index.vue'
export default {
  components: {
    Ola
  },
  computed: {
    ...mapGetters({
      diseaseType: 'getDiseaseType',
      getUserInfo: 'getUserInfo'
    }),
    key() {
      return this.$route.path
    }
  },
  watch:{
    $route(to,from){
      console.log(to)
      console.log(from)
      console.log(window.location)
    }
  },
  created() {
    // 在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem('store')) {
      // 存储状态
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
      sessionStorage.removeItem('store')
    }
    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })
  },
  mounted() {
    
    if(/AlipayClient/.test(window.navigator.userAgent)){
      return
    }
    setTimeout(() => {
      this.onGetDiseaseType();
      this.onHealthData()
      this.onGetThreeFactorsList()
      this.onGetSymptomTree()
    }, 2000)
  },
  methods: {
    ...mapActions({
      setDiseaseType: 'setDiseaseType',
      setHealthData: 'setHealthData',
      setThreeFactorsList: 'setThreeFactorsList',
      setSymptomTree: 'setSymptomTree'
    }),
    onGetDiseaseType() {
      getDiseaseType().then(({ data }) => { // 获取病种
        this.setDiseaseType(data.list || [])
      })
    },
    onHealthData() {
      getMemberHealthTagList().then(({ data }) => { // 获取健康档案数据
        this.setHealthData(data || {})
      })
    },
    onGetThreeFactorsList() {
      getThreeFactorsList().then(({ data }) => { // 获取三因
        this.setThreeFactorsList(data || [])
      })
    },
    async onGetSymptomTree() {
      try {
        const { data } = await getSymptomTree()
        this.setSymptomTree(data || [])
      } catch (error) {
        console.log(error)
      }
    },
  }
}
</script>
<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333; 
  background: #F2F2F2;
  min-height: 100vh;
  // overflow-y: auto;
}

body {
  max-width: 640px;
  margin: 0 auto !important;
}

.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all .5s;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.viewer-list {
  display: flex;
}

.van-popup {
  .van-popover__action-text {
    white-space: nowrap;
  }
}
</style>
